module.exports = __webpack_public_path__ + "static/img/gz-img03.58aa0d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gz-img03.png
// module id = ws4E
// module chunks = 1